import { useNavigate, useParams } from 'react-router-dom';
import { Stakeholder } from 'services/person/person.types';
import { useAddOrUpdateUserStakeholderMutation, useGetPersonStakeholderMutation } from 'services/person/stakeholder/stakeholder.endpoint';
import { useEffect, useState } from 'react';
import { useApiToast } from 'components/Toaster';

export default function usePersonStakeholderFormVM() {

    const [addOrUpdateStakeholder, { isLoading: isAddOrUpdateStakeholderLoading, isError, isSuccess, error: projectRequestsError, data: projectRequestsResponse }] = useAddOrUpdateUserStakeholderMutation();
    const navigate = useNavigate();
    const [stakeholder, setStakeholder] = useState<Stakeholder>();
    const { showApiToast, showErrorToast } = useApiToast();

    const { personId, stakeholderId } = useParams();
    const isEdit = stakeholderId != null;

    const [
        getPersonStakeholder,
        {
            isLoading: isGetPersonDetailsLoading,
            isError: isGetPersonDetailsError,
            isSuccess: isGetPersonDetailsSuccess,
            error: personDetailsError,
            data: personDetailsResponse
        }
    ] = useGetPersonStakeholderMutation();

    useEffect(() => {
        if (personId && stakeholderId) {
            getPersonStakeholder({ id: parseInt(personId), stakeholderId: parseInt(stakeholderId) });
        }
    }, [personId, stakeholderId, getPersonStakeholder]);

    useEffect(() => {
        if (isGetPersonDetailsLoading) return;
        if (isGetPersonDetailsError && personDetailsError) {
            showErrorToast(personDetailsError, {
                message: 'Erreur de chargement du proche'
            });
            return;
        }
        if (isGetPersonDetailsSuccess && personDetailsResponse) {
            setStakeholder(personDetailsResponse.data);
            return;
        }
    }, [isGetPersonDetailsLoading, isGetPersonDetailsError, isGetPersonDetailsSuccess, personDetailsError, personDetailsResponse, showErrorToast]);


    const handleAddOrEditStakeholder = async (data: Stakeholder) => {
        if (!personId) return;

        try {
            await addOrUpdateStakeholder({
                id: parseInt(personId),
                body: data
            })
            navigate(`/app/admin/persons/${personId}/stakeholders`);
        } catch (error) {
            console.error('rejected', error);
        }
    }

    return {
        isEdit,
        stakeholderValues: stakeholder,
        handleAddOrEditStakeholder,
        isLoading: isGetPersonDetailsLoading || isAddOrUpdateStakeholderLoading,
        isError, isSuccess, projectRequestsError, projectRequestsResponse
    };
}
